import createBehavior from '../create-behavior';
import $ from 'jquery';
import 'popper.js';
import 'bootstrap';
import 'bootstrap-select';

export default () => {
  class SelectPicker {
    constructor($el, context, settings) {
      this.init($el);
    }
    init($el) {
      this.addExtra($el);
      $.fn.selectpicker.Constructor.DEFAULTS.whiteList.span = ['data-val'];
      $.fn.selectpicker.Constructor.DEFAULTS.multipleSeparator = ' ';
      $.fn.selectpicker.Constructor.DEFAULTS.noneSelectedText = 'Sélectionner le type de commande';
      $el.selectpicker({
        size: 'false'
      });
      this.addRemoveIcon($el);
      $el.on('changed.bs.select', (e, clickedIndex, isSelected, previousValue) => {
        this.addRemoveIcon($el);
      });
    }
    addRemoveIcon($el) {
      let attr = $el.attr('multiple');
      if (typeof attr !== typeof undefined && attr !== false) {
        let $checked = $el.next('.dropdown-toggle').find('.rounded-pill');
        $.each($checked, (k, v) => {
          $(v).append('<i>×</i>')
        });
        this.remove($el);
      }
    }
    remove($el) {
      $el.next('.dropdown-toggle').find('.rounded-pill').find('i').on('click', (e) => {
        let currentValue = $(e.target).parents('.rounded-pill').data('val').toString();
        let values = $el.selectpicker('val');
        $el.selectpicker('val', values.filter(el => el !== currentValue));
        this.addRemoveIcon($el);
      });
    }
    addExtra($el) {
      let option = $el.find('option');
      option.each(function () {
        let optionval = $(this).text();
        let optiondata = $(this).attr('value');

        if( optiondata.length > 0) {
          $(this).attr('data-content', '<span data-val=\''+optiondata+'\' class=\'btn btn-sm btn-outline-danger rounded-pill\'>'+optionval+'</span>');
        }
      })
    }
  }

  createBehavior('.form-select, .selectpicker', 'SelectPicker', SelectPicker);
}



// WEBPACK FOOTER //
// ./js/src/behaviors/selectPicker.js